import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";

import Loader from "../../components/Loader";
import { useCommonContext } from "../../utils/context";

const TicketPieChart = () => {
  const { ticketStats, isloading } = useCommonContext();

  const STATUS_COLORS = {
    Accepted: "#28a745",   
    "Not-Assigned":"#343a40",
    Rejected: "#dc3545",
    Ongoing: "#ffc107",
    Completed: "#0088FE",
    "On-hold": "#fd7e14",
    Autoclose: "#800080",
    Inactive: "#6c757d",
    Default: "#343a40",
  };

  if (isloading.tickets) {
    return <Loader />;
  }

  const pieData = Object.entries(ticketStats)
    .filter(([key, value]) => key !== "total" && value > 0)
    .map(([key, value]) => ({
      name: key.charAt(0).toUpperCase() + key.slice(1),
      value,
    }));

  const totalTickets = ticketStats?.total || 0;

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
        >
          {pieData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={STATUS_COLORS[entry.name] || STATUS_COLORS.Default}
            />
          ))}
        </Pie>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: "20px", fontWeight: "bold" }}
        >
          Total: {totalTickets}
        </text>
        <Tooltip />
        <Legend verticalAlign="bottom" align="center" />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default TicketPieChart;
